import { render, staticRenderFns } from "./B2C_Form.vue?vue&type=template&id=431f77e8&scoped=true"
import script from "./B2C_Form.vue?vue&type=script&lang=js"
export * from "./B2C_Form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "431f77e8",
  null
  
)

export default component.exports